import { CheckboxField as FieldDefinition } from '@bybeam/platform-types';
import Checkbox from '@platform-ui-common/components/Checkbox/index.js';
import Typography from '@platform-ui-common/components/Typography/index.js';
import {
  GenericFormData,
  fieldUpdate,
  updateRepeated,
} from '@platform-ui-common/hooks/useForm/index.js';
import { FieldContext } from '@platform-ui/utilities/application/fields/index.js';
import cx from 'classnames';
import { FieldProps } from './types.js';

export default function CheckboxField<FormData extends GenericFormData>({
  field: { key, copy },
  answers,
  context,
  dispatch,
  errors,
  repeated,
  validation,
  setValidationOverrides: _,
  ...rest
}: FieldProps<FieldDefinition, FormData>): JSX.Element {
  return (
    <div
      className={cx('flex flex-col w-full items-center', {
        'lg:max-w-[36rem]': context !== FieldContext.Panel,
      })}
    >
      <Checkbox
        label={
          <Typography variant="body" tag="span">
            {copy}
            {validation?.required && '*'}
          </Typography>
        }
        checked={answers[key]}
        onClick={(): void =>
          repeated
            ? dispatch(updateRepeated(repeated.parentKey, repeated.index, key, !answers[key]))
            : dispatch(fieldUpdate(key, !answers[key] as FormData[typeof key]))
        }
        error={errors[key] as string}
        {...rest}
      />
    </div>
  );
}
